export interface UserInfo {
  browser: {
    userAgent: string;
    language: string;
    platform: string;
    screenResolution: string;
    timeZone: string;
    cookiesEnabled: boolean;
    doNotTrack: string | null;
    vendor: string;
  };
  network?: {
    connectionType?: string;
    effectiveType?: string;
    downlink?: number;
    rtt?: number;
  };
  geolocation?: {
    latitude?: number;
    longitude?: number;
    accuracy?: number;
  };
  timestamp: string;
}

export const getUserInfo = async (): Promise<UserInfo> => {
  const nav = window.navigator;
  const screen = window.screen;

  // Basic browser information
  const info: UserInfo = {
    browser: {
      userAgent: nav.userAgent,
      language: nav.language,
      platform: nav.platform,
      screenResolution: `${screen.width}x${screen.height}`,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      cookiesEnabled: nav.cookieEnabled,
      doNotTrack: nav.doNotTrack,
      vendor: nav.vendor,
    },
    timestamp: new Date().toISOString(),
  };

  // Network information if available
  if ('connection' in nav) {
    const conn = (nav as any).connection;
    if (conn) {
      info.network = {
        connectionType: conn.type,
        effectiveType: conn.effectiveType,
        downlink: conn.downlink,
        rtt: conn.rtt,
      };
    }
  }

  // Get geolocation if available and permitted
  if ('geolocation' in nav) {
    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        nav.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        });
      });

      info.geolocation = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy
      };
    } catch (error) {
      console.log('Geolocation error or permission denied:', error);
    }
  }

  return info;
};